import {Component, HostBinding, Input} from '@angular/core';
import {SvgIconComponent} from "angular-svg-icon";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-x-tab-segment',
  standalone: true,
  imports: [SvgIconComponent, NgIf],
  templateUrl: './x-tab-segment.component.html',
  styleUrl: './x-tab-segment.component.less',
})
export class XTabSegmentComponent {
  @HostBinding('class.active') @Input() active: boolean = false;
  @HostBinding('class.disabled') @Input() disabled: boolean | undefined = false;

  @Input() icon: string | undefined;
}
